/**
 * Represents the params to be sent in a POST request to /users/{user_id}/invite
 *
 * @type {object}
 */
export const INVITE_PARAMS = {
  FIRST_NAME: 'first_name',
  LAST_NAME: 'last_name',
  EMAIL: 'email',
  PHONE: 'phone'
};